import { css } from 'styled-components/macro';

export const BaseContent = css`
  ${({ theme }) => css`
    box-sizing: border-box;
    z-index: 9999;
    padding: ${theme.spacings.xs};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xxs};
    min-width: 200px;
    background: ${theme.semantic.bg.surface};
    border: 1px solid ${theme.semantic.menu.border};
    border-radius: ${theme.radiuses.s};
    will-change: transform, opacity;
    animation-duration: ${theme.tokens.animation.duration.base};
    animation-timing-function: ${theme.tokens.animation.easing.standard};
    overflow-y: auto;
    overflow-x: hidden;
  `};
`;

export const BaseItem = css<{
  $critical?: boolean;
}>`
  box-sizing: border-box;
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 32px;
  cursor: pointer;
  outline: none;
  user-select: none;

  ${({ theme, $critical }) => css`
    padding-inline: ${theme.spacings.s};
    gap: ${theme.radiuses.xs};
    border-radius: ${theme.radiuses.xxs};
    color: ${$critical
      ? theme.semantic.action.critical.text
      : theme.semantic.text.default};
    transition-property: background-color, color;
    transition-duration: ${theme.tokens.animation.duration.base};

    &:hover,
    &:focus,
    &[data-state='open'] {
      background-color: ${$critical
        ? theme.semantic.action.critical.bgHover
        : theme.semantic.bg.surface2Hover};
      color: ${$critical
        ? theme.semantic.action.critical.textHover
        : 'currentColor'};
    }

    &[data-disabled] {
      color: ${theme.semantic.text.disabled};
      cursor: not-allowed;
    }
  `};
`;

export const BaseSubContent = css`
  ${BaseContent};
`;

export const BaseSubTrigger = css`
  ${BaseItem};
`;

export const BaseCheckboxItem = css`
  ${({ theme }) => css`
    ${BaseItem};
    padding-right: 32px; // Резервируем место для индикатора

    &[data-state='checked'] {
      padding-right: ${theme.spacings.s};
      background-color: ${theme.semantic.bg.selected};
    }
  `}
`;

export const BaseIndicator = css`
  ${({ theme }) => css`
    box-sizing: border-box;
    margin-left: auto;
    width: 16px;
    height: 16px;
    color: ${theme.semantic.icon.accent};
  `};
`;

export const BaseSeparator = css`
  box-sizing: border-box;
  min-height: 1px;

  ${({ theme }) => css`
    margin-block: ${theme.spacings.xxs};
    background-color: ${theme.semantic.border.default};
  `};
`;
